import React from "react";
import { Link } from "@reach/router";
import { Nav as BootNav } from "react-bootstrap";

export default function Nav() {
  const NavLink = (props: any) => (
    <Link
      {...props}
      getProps={({ isCurrent, location }) => {
        // the object returned here is passed to the
        // anchor element's props
        return {
          className: `${
            isCurrent || (location.key === "initial" && props.to === "/")
              ? "active"
              : ""
          } super nav-link`,
        };
      }}
    />
  );

  return (
    <BootNav className="ml-4 mb-4" variant="pills">
      <BootNav.Item>
        <NavLink to="/">Dashboard</NavLink>
      </BootNav.Item>
      <BootNav.Item>
        <NavLink to="/ltc">LTC</NavLink>
      </BootNav.Item>
      <BootNav.Item>
        <NavLink to="/school">School</NavLink>
      </BootNav.Item>
    </BootNav>
  );
}
